import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Extract error string from error object, originalError, or reason
    const errorMsg =
      error?.message ||
      error?.originalError?.message ||
      error?.reason?.message ||
      error?.toString() ||
      '';

    // Matches all major browser variants of dynamic import / chunk failures:
    // 1. Chrome / Chromium / Edge: "Failed to fetch dynamically imported module: ..."
    // 2. Mobile Safari / Desktop Safari: "Importing a module script failed."
    // 3. Firefox / Webpack default: "Loading chunk 123 failed."
    // 4. Standalone network fetch failures on .js chunk files
    const chunkFailedPattern =
      /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk [\d]+ failed|error loading chunk/i;

    if (chunkFailedPattern.test(errorMsg)) {
      const hasReloaded = sessionStorage.getItem('chunk_reload_attempted');

      if (!hasReloaded) {
        // Prevent infinite reload loops if network is completely disconnected
        sessionStorage.setItem('chunk_reload_attempted', 'true');
        console.warn('Deployment chunk mismatch detected. Reloading application...');
        
        // Force page reload to fetch the latest index.html and fresh chunks
        window.location.reload();
        return;
      } else {
        console.error('Chunk loading failed after reload. Please check network connection.');
      }
    }

    // NEW: Handle IndexedDB connection closure during page unload or logout
    if (
      errorMsg.includes("Failed to execute 'transaction' on 'IDBDatabase'") ||
      errorMsg.includes('The database connection is closing') ||
      error?.name === 'InvalidStateError'
    ) {
      console.warn('IndexedDB transaction interrupted during page navigation/reload:', errorMsg);
      return; // Ignore and suppress harmless storage teardown error
    }
    // NEW: Suppress PushManager Service Worker timing issues
    if (
      errorMsg.includes("Failed to execute 'subscribe' on 'PushManager'") ||
      errorMsg.includes('no active Service Worker') ||
      error?.name === 'AbortError'
    ) {
      console.warn('PushManager subscription attempted before Service Worker was ready:', errorMsg);
      return;
    }

    // Log all other standard runtime application errors
    console.error('Unhandled Application Error:', error);
  }
}